import { AuthService } from "@/modules/auth/services/auth.service";
import { logout } from "@/modules/auth/store/auth.store";
import { DiContainer } from "@/modules/di/di-container";


export async function logoutUtility() {
    const authService = DiContainer.get(AuthService);

    const res = await authService.checkAuth();
    const isAuthTokenValid = res.isValid;

    if (isAuthTokenValid) return;

    // notification.warning({ message: 'Ваша сессия устарела, пройдите, пожалуйста, повторную авторизацию в системе' });
    logout();
    //await authService.logout();
    // authService.loginInSso();
}